import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: { user: null, roles: null, token: null },
  reducers: {
    setCredentials: (state, { payload: { user, roles, accessToken } }) => {
      state.user = user;
      state.roles = roles;
      state.token = accessToken;
    },
    logOut: (state, action) => {
      state.user = null;
      state.token = null;
      state.roles = null;
    },
  },
});

export const { setCredentials, logOut } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentRoles = (state) => state.auth.roles;
export const selectCurrentToken = (state) => state.auth.token;
